import api from '@/apis/di/purchasePurposeAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('purchasePurpose', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_purchase_purpose',
    field: {
      key: 'purchase_purpose_id',
      code: 'purchase_purpose_code',
      name: 'purchase_purpose_name',
      quickFollow: 'inactive', // NTLoc-2022/05/06 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
